module.exports = __webpack_public_path__ + "static/img/top.b7996013.png";